import React from 'react';

import RefererItem from 'components/refererItem';
import BarberProfileMetaChip from 'components/barberProfileMetaChip';
import { Space } from 'components/barbr';
import tiktokIcon from 'assets/icons/tiktok-color.png';
import instagramIcon from 'assets/icons/instagram-color.png';

import ProfileCover from '../../components/cover';
import MobileProfileAddress from '../../mobile/address';

const MobileProfileBasicDetail = React.memo(({ detail, address, schedules, isLoggedIn, referrral }) => (
  <div className='basic-detail'>
    <ProfileCover detail={detail} />
    <div className='container'>
      <Space justify='space-between' align='center'>
        <BarberProfileMetaChip detail={detail} />
        <Space size={16} justify='justify-center'>
          <If condition={detail.instagram_url}>
            <a href={detail.instagram_url} target='_blank' rel='noreferrer'>
              <img width={20} height={20} alt='Instagram' src={instagramIcon} />
            </a>
          </If>
          <If condition={detail.tiktok_url}>
            <a href={detail.tiktok_url} target='_blank' rel='noreferrer'>
              <img src={tiktokIcon} alt='Tiktok' width={20} height={20} />
            </a>
          </If>
        </Space>
      </Space>
      <RefererItem referrral={referrral} isLoggedIn={isLoggedIn} username={detail.username} />
      <MobileProfileAddress address={address} schedules={schedules} shop={(detail.shop_detail || []).length && detail.shop_detail[0]} />
      <If condition={detail.about}>
        <div className='section'>
          <p className='text-xl light about'>{detail.about}</p>
        </div>
      </If>
    </div>
  </div>
));

export default MobileProfileBasicDetail;
